import {BaseApi} from "../BaseApi";

export class ConnectionsApi extends BaseApi {
    public getConnectionsList(id: number): Promise<any> {
        return this.get("/connection/list/:integrationId", {params: {integrationId: id}})
    }
}